import React, { useState, useEffect } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Input, Button } from '../../../Atoms';
import { ErrorIcon } from '../../../Assets';
import { Logo } from '../../../Assets';
import { StepIndicator } from '../../../components';
import { 
  verifyCompanyCode, 
  resetOnboarding 
} from '../../../redux/actions/OnboardingAction';

import './company-code.scss';

const CompanyCode = ({
  verifyCompanyCode,
  companyCodeVerification: { loading, error, success, data },
  resetOnboarding,
}) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    company_code: ''
  });
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    // Reset onboarding state when component mounts
    resetOnboarding();
  }, [resetOnboarding]);

  useEffect(() => {
    if (success && data) {
      console.log('✅ Company code verification successful');
      console.log('Session ID:', data.session_id);
      console.log('Company name:', data.company_name);
      console.log('Support email:', data.support_email);
      
      // Store session data and navigate to profile setup
      localStorage.setItem('onboarding_session_id', data.session_id);
      localStorage.setItem('company_name', data.company_name);
      localStorage.setItem('support_email', data.support_email);
      
      console.log('✅ Session data stored in localStorage');
      history.push('/onboarding/profile-setup');
    }
  }, [success, data, history]);


  const handleSubmit = () => {
    verifyCompanyCode(formData);
  };


  const handleChange = ({ target: { name, value } }) => {
    // Convert to uppercase for company codes
    setFormData({ ...formData, [name]: value.toUpperCase() });
    
    // Clear validation errors when user starts typing
    if (validationErrors[name]) {
      setValidationErrors({ ...validationErrors, [name]: null });
    }
  };

  return (
    <div className="company-code-wrapper">
      <div className="company-code-form">
        <div className="logo-wrapper">
          <Logo />
        </div>
        
        <StepIndicator currentStep={1} totalSteps={3} />
        
        <div className="heading">Enter Company Code</div>
        <div className="subheading">
          Please enter your company code to get started with Peak Mind.
        </div>
        
        {error && (
          <div className="error-wrapper">
            <div>
              <ErrorIcon />
            </div>
            <span>{error}</span>
          </div>
        )}

        <ValidatorForm onSubmit={handleSubmit} className="form">
          <Input
            onChange={handleChange}
            value={formData.company_code}
            title="Company Code *"
            placeholder="Enter your company code"
            name="company_code"
            validators={['required']}
            errorMessages={['Company code is required']}
            formValid={!error}
            style={{ marginBottom: 24 }}
          />

          <div className="help-text">
            <p>
              Don't have a company code? Contact your administrator or email{' '}
              <a href="mailto:support@joinpeakmind.com">support@joinpeakmind.com</a>
            </p>
          </div>

          <div className="action-btn">
            <Button type="submit" size="sm" color="blue" loading={loading}>
              Continue
            </Button>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  companyCodeVerification: state.onboarding.companyCodeVerification,
});

const mapDispatchToProps = (dispatch) => ({
  verifyCompanyCode: (details) => {
    dispatch(verifyCompanyCode(details));
  },
  resetOnboarding: () => {
    dispatch(resetOnboarding());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCode);


